import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  location: string;
  age: number;
  text: string;
}
export function TestimonialCard({
  name,
  location,
  age,
  text
}: TestimonialProps) {
  return <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300" data-id="element-60">
      <div className="flex gap-1 mb-4" data-id="element-61">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-62" />)}
      </div>
      <p className="text-gray-600 mb-6 italic leading-relaxed" data-id="element-63">"{text}"</p>
      <div className="flex items-center gap-3" data-id="element-64">
        <div className="w-10 h-10 rounded-full bg-[#7DD3E8]/20 flex items-center justify-center text-[#008CB4] font-bold text-sm" data-id="element-65">
          {name.charAt(0)}
        </div>
        <div data-id="element-66">
          <p className="font-semibold text-gray-900" data-id="element-67">
            {name}, {age}
          </p>
          <p className="text-xs text-gray-500" data-id="element-68">{location}</p>
        </div>
      </div>
    </div>;
}